/** 刚通过 addV1 上传的角色，在列表 URL 尚未可访问时用本地预览 */

type LocalPreview = {
  blob: Blob
  url: string
  dataUrl: string
}

const previews = new Map<number, LocalPreview>()

export function toCharacterResourceId(id: unknown): number | undefined {
  if (id == null || id === '') return undefined
  const n = Number(id)
  return Number.isFinite(n) && n > 0 ? n : undefined
}

export function parseCharacterSlotResourceId(slotId?: string | number): number | undefined {
  if (typeof slotId === 'number') return toCharacterResourceId(slotId)
  if (!slotId) return undefined
  const matched = String(slotId).match(/^character-(\d+)$/)
  return toCharacterResourceId(matched?.[1] ?? slotId)
}

function readAsDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result || ''))
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(blob)
  })
}

async function blobToChipDataUrl(blob: Blob, size = 80): Promise<string> {
  try {
    const bitmap = await createImageBitmap(blob)
    const canvas = document.createElement('canvas')
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext('2d')
    if (!ctx) {
      bitmap.close()
      return readAsDataUrl(blob)
    }
    const scale = Math.max(size / bitmap.width, size / bitmap.height)
    const width = bitmap.width * scale
    const height = bitmap.height * scale
    ctx.drawImage(bitmap, (size - width) / 2, (size - height) / 2, width, height)
    bitmap.close()
    return canvas.toDataURL('image/jpeg', 0.72)
  } catch {
    return readAsDataUrl(blob)
  }
}

export async function rememberCharacterLocalPreview(resourceId: unknown, file: Blob) {
  const id = toCharacterResourceId(resourceId)
  if (!id) return
  const previous = previews.get(id)
  if (previous) URL.revokeObjectURL(previous.url)
  const url = URL.createObjectURL(file)
  const dataUrl = await blobToChipDataUrl(file)
  previews.set(id, { blob: file, url, dataUrl })
}

export function getCharacterLocalPreview(resourceId?: unknown): string | undefined {
  const id = toCharacterResourceId(resourceId)
  if (!id) return undefined
  const entry = previews.get(id)
  return entry?.dataUrl || entry?.url
}

export function getCharacterLocalBlobUrl(resourceId?: unknown): string | undefined {
  const id = toCharacterResourceId(resourceId)
  if (!id) return undefined
  return previews.get(id)?.url
}
